<template>
  <div id="tryout-form">
    <ol class="breadcrumb pull-right">
      <li>
        <router-link :to="{ path: '/' }">Home</router-link>
      </li>
      <li class="active">Redeem Affiliate</li>
    </ol>
    <h1 class="page-header">Redeem Affiliate</h1>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">List Redeem</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-12">
                <div class="row" style="padding-bottom: 15px;">
                  <div
                    class="col-md-10"
                    style="
                      display: flex;
                      align-items: center;
                      padding-top: 10px;
                    "
                  >
                    <div class="input-group">
                      <span class="input-group-addon" id="basic-addon1"
                        ><i class="fa fa-search"></i
                      ></span>
                      <input
                        v-model="filter.search"
                        type="text"
                        class="form-control"
                        placeholder="Search"
                        aria-describedby="basic-addon1"
                        
                      />
                      <!-- @keypress.enter="submitFilter('search', filter.search)" -->
                    </div>
                  </div>
                </div>
                <div class="row">
                  
                  <div class="col-md-3" style="display: flex">
                    <div class="form-group">
                      <label>Start Date*</label>
                      <transition name="fade">
                        <div class="input-group">
                          <input
                            id="filterStart"
                            
                            v-model="filter.start_date"
                            type="text"
                            class="form-control datepicker"
                            name="discussion_date"
                            style="max-width: 100px;color: black !important;background: white !important;"
                            readonly
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </transition>
                    </div>
                    <!-- </div>
                  <div class="col-md-4"> -->

                    <div class="form-group" style="padding-left: 15px">
                      <label>End Date*</label>
                      <transition name="fade">
                        <div class="input-group">
                          <input
                            id="filterEnd"
                            v-model="filter.end_date"
                            type="text"
                            class="form-control datepicker"
                            name="discussion_date"
                            style="max-width: 100px;color: black !important;background: white !important;"
                            readonly
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </transition>
                    </div>
                  </div>
                  <div
                    class="col-md-2"
                    style="
                      display: flex;
                      align-items: center;
                      padding-top: 10px;
                    "
                  >
                  <!-- @change="submitFilter('status', filter.status)" -->
                    <select  v-model="filter.status" name="" id="" class="form-control">
                      <option value="">Semua Status</option>
                      <option :value="item.type" v-for="(item, index) in listStatus" :key="index">{{ item.title }}</option>
                      
                    </select>
                  </div>
                  <div
                    class="col-md-2"
                    style="
                      display: flex;
                      align-items: center;
                      padding-top: 10px;
                    "
                  >
                  <!-- @change="submitFilter('wallet_type', filter.wallet_type)" -->
                    <select  v-model="filter.wallet_type" name="" id="" class="form-control">
                      <option value="">Semua Tipe E-wallet</option>
                      <option :value="item.type" v-for="(item, index) in listWallet" :key="index">{{ item.title }}</option>
                    </select>
                  </div>
                  <div
                    class="col-md-2"
                    style="
                      display: flex;
                      align-items: center;
                      padding-top: 10px;
                    "
                  >
                  <button @click="submitFilter('sort_mode', 'ASC')" v-if="filter.sort_mode == 'DESC'" class="btn btn-success btn-md">sort : DESC</button>
                  <button @click="submitFilter('sort_mode', 'DESC')" v-if="filter.sort_mode == 'ASC'" class="btn btn-success btn-md">sort : ASC</button>
                </div>
                <div
                    class="col-md-2"
                    style="
                      display: flex;
                      align-items: center;
                      padding-top: 10px;
                    "
                  >
                  <button class="btn btn-success btn-md" @click="applyFilter()">Apply</button> &nbsp;
                  <button class="btn btn-danger btn-md" @click="resetFilter()">Reset</button>
                </div>
                </div>

                <div class="list-group">
                  <div
                    class="list-group-item"
                    style="display: flex; flex-flow: row;"
                  >
                    <div class="col-md-2 col-xs-4">Tanggal</div>
                    <div class="col-md-3 col-xs-4">Username</div>
                    <div class="col-md-2 col-xs-2">Jumlah redeem</div>
                    <div class="col-md-2 col-xs-2">E-Wallet</div>
                    <div class="col-md-3 col-xs-2">Status Redeem</div>
                </div>
                  <a
                    class="list-group-item"
                    style="display: flex; flex-flow: row"
                    v-for="item in redeemList"
                    :key="item"
                    @click="item.status !== 'REFUND' ? showDetail(item) : ''"
                  >
                    <div class="col-md-2 col-xs-4">
                      {{ item.created_at | convertDate }}
                    </div>
                    <div class="col-md-3 col-xs-4">{{ item.member_name }}</div>
                    <div class="col-md-2 col-xs-2">
                      {{ item.coin | currency }} koin
                    </div>
                    <div class="col-md-2 col-xs-2">{{ item.wallet_type }}</div>
                    <div class="col-md-3 col-xs-2">
                      <button v-if="item.status === 'FAILED'" class="btn btn-danger btn-sm">
                        Gagal
                      </button>
                      <button v-if="item.status === 'REFUND'" class="btn btn-default btn-sm">
                        Dikembalikan
                      </button>
                      <button v-if="item.status === 'ONPROGRESS'" class="btn btn-warning btn-sm">
                        Proses
                      </button>
                      <button v-if="item.status === 'SUCCESSED'" class="btn btn-success btn-sm">
                        Berhasil
                      </button>
                      <!-- <button> -->
<!-- 
                      </button>
                      <button :class="item.status === 'FAILED' ? 'btn btn-danger btn-sm' : item.status === 'REFUND' ? 'btn btn-default btn-sm' : item.status === 'ONPROGRESS' ? 'btn btn-warning btn-sm' : 'btn btn-success btn-sm'">
                        {{ item.status }}
                      </button> -->
                    </div>
                  </a>
                </div>

                <div class="col-md-3" style="display:flex; flex-flow:row; padding-top: 20px;">
                  <!-- Single button -->
                  <div class="btn-group" style="margin-right: 15px;">
                    <button type="button" class="btn btn-white dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                     {{ filter.page_size }} <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu">
                      <li><a @click="submitFilter('page_size', 10)">10</a></li>
                      <li><a @click="submitFilter('page_size', 15)">15</a></li>
                      <li><a @click="submitFilter('page_size', 25)">25</a></li>
                    </ul>
                  </div>

                  <div class="input-group">
                    <span class="input-group-btn" v-if="filter.page > 1">
                      <button class="btn btn-white" @click="submitFilter('page',filter.page - 1)" type="button" >Previous</button>
                    </span>
                    <input v-model="filter.page" readonly type="text" class="form-control" style="text-align:center;">
                    <span class="input-group-btn">
                      <button class="btn btn-white" @click="submitFilter('page', filter.page + 1)" type="button">Next</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="redeemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">DETAIL REDEEM</h5>
          </div>
          <div class="modal-body">
            <div class="row mb-2">
              <div class="col-md-4">Tanggal Redeem</div>
              <div class="col-md-6">
                : &nbsp; {{ redeemDetail.created_at | convertDate }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">Nama</div>
              <div class="col-md-6">: &nbsp; {{ redeemDetail.member_name }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">Email</div>
              <div class="col-md-6">: &nbsp; {{ redeemDetail.member_email }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">Akun Ewallet</div>
              <div class="col-md-6">: &nbsp; {{ redeemDetail.wallet_account }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">E Wallet</div>
              <div class="col-md-6">: &nbsp; {{ redeemDetail.wallet_type }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">No E Wallet</div>
              <div class="col-md-6">: &nbsp; {{ redeemDetail.wallet_number }}</div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">Jumlah cashout</div>
              <div class="col-md-6">
                : &nbsp; Rp. {{ redeemDetail.rupiah | currency }}
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-4">Status</div>
              <div class="col-md-6" style="display: flex; flex-flow: row">
                : &nbsp;
                <select class="form-control" v-model="form.status">
                  <option :value="item.type" v-for="(item, index) in listStatus" :key="index" :disabled="item.type === 'REFUND' || item.type === 'ONPROGRESS'">{{ item.title }}</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">Notes (optional)</div>
              <div class="col-md-6" style="display: flex; flex-flow: row">
                : &nbsp;
                <textarea rows="5" v-model="form.note" class="form-control" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12" style="text-align: center">
                <button class="btn btn-default" @click="hideDetail()">
                  Cancel
                </button>
                <button
                v-if="varstate !== 'FAILED'"
                  class="btn btn-success"
                  @click="saveChanges(redeemDetail.id)"
                >
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <p id="msg"></p>
  </div>
</template>
<style>
.datepicker {
  min-width: 90px !important;
}
</style>
<script>
import Spinner from "@/components/plugins/Spinner";
import logo from "@/assets/img/launcher.png";
import AffService from "@/services/affiliate.js";
import moment from "moment";
// import AffiliateSetting from "../setting/AffiliateSetting.vue";
export default {
  name: "form-redeem-list",
  components: {
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      // filterStart: null,
      // filterEnd: null,
      redeemList: [],
      logo: logo,
      varstate: null,
      redeemDetail: {
        id: null,
        coin: 0,
        rupiah: 0,
        note: "",
        type: "",
        status: "",
        walletType: "",
        walletAccount: "",
        walletNumber: "",
        memberId: 0,
        memberName: "",
        memberEmail: "",
        memberCode: "",
        productId: null,
        productType: null,
        productTitle: null,
        productPrice: null,
        productCommission: null,
        createdAt: null,
        updatedAt: null,
        isActive: true,
      },
      isLoading: false,
      listWallet: [],
      listStatus: [],
      form: {
        note: "",
        status: "",
      },
      filter: {
        search: '',
        start_date: null,
        end_date: null,
        wallet_type: '',
        status: '',
        page: 1,
        sort_mode: 'DESC',
        page_size: 10
      }
    };
  },
  filters: {
    convertDate(v) {
      return moment.unix(v).format("DD MMMM YYYY");
    },
    currency(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  // watch: {
  //   filter:  {
  //     // This will let Vue know to look inside the array
  //     deep: true,
  //     // We have to move our method to a handler field
  //     handler: function (val, oldVal) {
  //       var context = this;
  //       context.getList();
  //       // context.showSave = true;
  //     },
  //   },
  // },
  methods: {
    showDetail(val) {
      this.redeemDetail = val;
      this.form.status = val.status;
      this.form.note = val.note;
      this.varstate = val.status
      $("#redeemModal").modal("show");
    },
    resetFilter(){
      this.filter = {
        search: '',
        start_date: null,
        end_date: null,
        wallet_type: '',
        status: '',
        page: 1,
        sort_mode: 'DESC',
        page_size: 10
      }
      this.getList()
    },
    hideDetail() {
      $("#redeemModal").modal("hide");
    },
    saveChanges(id) {
      let context = this;
      
      if(context.form.status === 'FAILED' && (context.form.note === '' || context.form.note === null)) {
        alert('Status gagal note wajib diisi')
      } else {
        context.isLoading = true;
        AffService.updateStatusRedeem([id, context.form], function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("data berhasil diubah");
            context.hideDetail()
            context.getList()
          } else {
            alert('gagal ubah data')
          }
        });
      }
      
    },
    getWallet(id){
      let context = this
      AffService.getRedeemWallets(function (result) {
        if (result.success) {
          context.listWallet = result.data
        }
      });
    },
    getStatus(id){
      let context = this
      AffService.getRedeemStatus(function (result) {
        if (result.success) {
          context.listStatus = result.data
        }
      });
    },
    submitFilter(field, val){
      if(field !== 'page') this.filter.page = 1
      this.filter[field] = val
      this.getList()
    },
    applyFilter(){
      this.filter.page = 1
      this.getList()
    },
    getList() {
      let context = this;
      context.isLoading = true;
      AffService.getRedeemList(context.filter, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.redeemList = result.data.data;
        }
      });
    },
  },
  mounted: function () {
    this.getList();
    this.getWallet()
    this.getStatus()
    var context = this;
    DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
    });
    DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
    });
  },
};
</script>



// WEBPACK FOOTER //
// AffiliateRedeem.vue?292a082c